import React from "react";
import className from "classnames/bind";
import styles from "../OrderInfoPage.module.scss";
import useTranslations from "../../../hooks/useTranslations";

const cx = className.bind(styles);

const PersonalInfoForm = ({ formData, handleInputChange }) => {
  const translations = useTranslations();

  return (
    <div className={cx("section")}>
      <h2>{translations?.Checkout?.my_info || "My Information"}</h2>
      <div className={cx("form-group")}>
        <input
          type="email"
          name="email"
          placeholder={translations?.PlaceHolder?.Email || "Email address"}
          value={formData.email}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className={cx("form-group")}>
        <input
          type="tel"
          name="phone"
          placeholder={translations?.PlaceHolder?.Phone || "Phone Number"}
          value={formData.phone}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className={cx("form-row", "two-row", "between")}>
        <input
          type="text"
          name="firstName"
          placeholder={translations?.PlaceHolder?.First_name || "FirstName"}
          value={formData.firstName}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="lastName"
          placeholder={translations?.PlaceHolder?.Last_name || "LastName"}
          value={formData.lastName}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className={cx("form-group")}>
        <textarea
          id="orderComments"
          name="orderComments"
          placeholder="Write your note here..."
          value={formData.orderComments}
          onChange={handleInputChange}
        ></textarea>
      </div>
    </div>
  );
};

export default PersonalInfoForm;
